// 세션 창이 접속에 쓸 토큰을 고르는 **규칙**(tokenBroker.ts 가 실제 통로·JWT 해석을 끼워 쓴다).
// 의존성을 두지 않는다 — Node 단위 시험(test/token-policy.test.ts)이 그대로 불러온다.

/** 새 토큰을 받지 못해 접속을 시작할 수 없을 때의 안내(메인 창 없음·로그아웃·다른 계정). */
export const LOGIN_EXPIRED_MESSAGE = '로그인이 만료되어 다시 연결할 수 없습니다. 메인 창에서 다시 접속하세요.';

/** 규칙이 쓰는 바깥 기능 — 실제 값은 tokenBroker.ts 가 넣는다. */
export interface TokenPolicyDeps {
  /** 메인 창에 새 토큰을 묻는다(못 받으면 빈 문자열). */
  ask: () => Promise<string>;
  /** 토큰 만료 시각(ms) — 모르면 null(= 만료로 보고 새것을 묻는다). */
  expiryMs: (token: string) => number | null;
  /** 토큰의 사용자(sub) — 모르면 null. */
  subject: (token: string) => string | null;
  /** 남은 시간이 이보다 적으면 새것을 묻는다(ms). */
  marginMs: number;
  /** 지금 시각(ms) — 시험에서 바꿔 끼운다. */
  now?: () => number;
}

/**
 * 접속에 쓸 접근 토큰을 확보한다 — 아직 넉넉하면 그대로, 곧 만료되거나 만료됐으면 메인 창에 새것을 묻는다.
 * @throws `LOGIN_EXPIRED_MESSAGE` — 새 토큰을 못 받았거나 **다른 계정** 토큰이 왔다(메인 창에서 로그아웃 후 다른 사람이 로그인).
 *   🔴 다른 계정으로 조용히 이어 붙이면 감사 기록·권한이 엉뚱한 사람 것이 된다 → 거절한다.
 */
export async function ensureUsableTokenWith(token: string, d: TokenPolicyDeps): Promise<string> {
  const now = d.now ?? Date.now;
  const exp = d.expiryMs(token);
  if (exp !== null && exp - now() > d.marginMs) {
    return token;
  }
  const fresh = await d.ask();
  const who = d.subject(token);
  if (!fresh || !who || d.subject(fresh) !== who) {
    throw new Error(LOGIN_EXPIRED_MESSAGE);
  }
  return fresh;
}
